export enum ConfirmDialogVariant {
  Success = 'success',
  Error = 'error',
  Information = 'information',
  Warning = 'warning',
}
